export default "/storefront/client/images/free-shipping.png";